import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import warning from "../../assets/logo/warning.png";

export default function ErrorCart({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="column"
            px="4"
            width="full"
          >
            <img
              src={warning}
              alt="Logo"
              style={{
                borderRadius: "5px",
                maxWidth: "200px",
                maxHeight: "200px",
              }}
            />
            <Box textAlign="center" py="5">
              <Text fontWeight="700" fontSize="20">
                Perhatian
              </Text>
              <Text fontWeight="400" fontSize="12">
                Keranjang anda yang sebelumnya akan dihapus apabila menambahkan
                item dari perusahaan yang berbeda
              </Text>
            </Box>
            <SimpleGrid columns={2} spacing={2}>
              <Link to="/keranjang">
                <Button
                  variant="outline"
                  width="full"
                  colorScheme="blue"
                  px="7"
                  fontWeight
                >
                  Batalkan
                </Button>
              </Link>
              <Button
                fontWeight
                variant="solid"
                width="full"
                colorScheme="blue"
                px="7"
              >
                Lanjut
              </Button>
            </SimpleGrid>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
